module.exports = __webpack_public_path__ + "img/accept.1b42de51.svg";